import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import config from '../config/config.json'

const url = "https://apicontrol.softcom.es/api/"
const urlLocal = "https://localhost:5000/api/"
const http = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? config.urlApi.dev : config.urlApi.prod
});

Vue.use(VueAxios, http);
